export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-hsv/src/constant.js
// module id = 1094
// module chunks = 4